module.exports = __webpack_public_path__ + "static/img/tupian.7265ec4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sicon/tupian.png
// module id = oF68
// module chunks = 15